var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.349,
    height: 19.559,
    viewBox: "0 0 10.349 19.559"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50",
    d: "M9.491.002a.858.858 0 01.607 1.464L1.783 9.781l8.315 8.315a.858.858 0 01-1.213 1.213L.454 10.878a1.555 1.555 0 010-2.2L8.885.247a.854.854 0 01.606-.245z",
    fill: "#750b22"
  })));
}

export default SvgArrow;